import { render } from "./GerenciarJogadores.vue?vue&type=template&id=aee94a20"
import script from "./GerenciarJogadores.vue?vue&type=script&lang=js"
export * from "./GerenciarJogadores.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__